module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('section', {
    staticClass: "main_section",
    class: {
      'pic--2': _vm.slogan === 1
    }
  }, [(_vm.slogan === 1 && false) ? _c('div', {
    staticClass: "slogan"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("來趟小旅行一塊學英語！")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("「新北市英語智慧城」提供創新型態的學習服務，透過熱門景點進行影音互動學習。和我們一起快樂玩，輕鬆學，走遍新北市景點，學好旅遊英語，收藏在地旅行的動人回憶。")])]) : _vm._e(), _vm._v(" "), (_vm.slogan === 2 && false) ? _c('div', {
    staticClass: "slogan2"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("新北市英語智慧城 APP")]), _vm._v(" "), _c('p', [_vm._v("新北市就是你的英語教室")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "sloganPagination text-xs-center"
  }, [_c('v-btn', {
    staticClass: "bg--primary",
    attrs: {
      "small": "",
      "floating": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sloganClick(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('v-btn', {
    staticClass: "bg--primary",
    attrs: {
      "small": "",
      "floating": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sloganClick(2)
      }
    }
  }, [_vm._v("2")])], 1) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--white",
    attrs: {
      "id": "anchor-1"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("功能特色")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("四大學習功能讓您邊玩邊學")]), _vm._v(" "), _c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "sm5": "",
      "offset-sm1": "",
      "pa-3": ""
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_video.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("互動課程")]), _vm._v(" "), _c('p', [_vm._v("包含實用會話、影音簡介、圖解單字與學習任務等學習功能，想知道新北市哪裡好玩，想要身歷其境，現場即時學英語，請立刻下載，讓『新北市英語智慧城』 APP 陪你一起暢新北市英語智慧城。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": "",
      "pa-3": ""
    }
  }, [_c('hr', {
    staticClass: "hidden-sm-and-up",
    staticStyle: {
      "margin-bottom": "1.5em"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_coin.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("暑假特別活動 / 來福幣兌換")]), _vm._v(" "), _c('p', [_vm._v("於暑假期間規劃了英語學習課程，讓學習者從問答中認識景點特色及相關英語，讓你邊玩邊學好英語，答對可獲得來福幣，還能兌換禮物哦！")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": "",
      "offset-sm1": ""
    }
  }, [_c('hr', {
    staticStyle: {
      "margin-bottom": "1.5em"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_location.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("GPS定位")]), _vm._v(" "), _c('p', [_vm._v("使用 GPS 定位快速找到鄰近的景點，跟著 APP 吃喝玩樂學英語，來趟不一樣的深度新北市之旅。")])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": ""
    }
  }, [_c('hr', {
    staticStyle: {
      "margin-bottom": "1.5em"
    }
  }), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "text-xs-center",
    attrs: {
      "xs3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_ar.svg")
    }
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs9": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("擴增實境")]), _vm._v(" "), _c('p', [_vm._v("採用創新擴增實境 (AR) 技術，進行打卡任務，連結景點場景，體驗浸潤式的英語學習樂趣。")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--primary",
    attrs: {
      "id": "anchor-2"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("熱門景點")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("最受歡迎的新北市熱門景點大推薦")]), _vm._v(" "), _c('v-row', {
    staticClass: "text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_01.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("九份老街")]), _vm._v(" "), _c('p', [_vm._v("九份老街為基山街，昔日稱為「暗街仔」，為九份主要街道，商店林立。在九份的巷弄中，可以多走樓梯，隨處繞繞，逛逛各式各樣的特色小店，發現九份山城之美。")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_02.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("深坑老街")]), _vm._v(" "), _c('p', [_vm._v("深坑，一個距離有點遠又不太遠的遠離市區商圈，是個半日遊的好選擇! 因為清澈的水質以及特殊鹽滷製法所製作的豆腐，其炭味口感吸引了許多饕客，成為一般人熟知的「豆腐故鄉」，也因此造就了老街的繁榮。")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_04.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("黃金博物館")]), _vm._v(" "), _c('p', [_vm._v("黃金博物館是國內首座以礦業文化保存為宗旨的公立博物館，建館之初即以生態博物館為理念規劃，將礦業文化保存與再現，歡迎一同體驗與發現金瓜石特殊的自然生態以及歷史人文之美。")])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm3": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/p_03.png"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("朱銘美術館")]), _vm._v(" "), _c('p', [_vm._v("台灣當代雕塑大師「朱銘」選在有好山好水的金山地區，規劃出佔地11公頃的藝術公園，依據不同地貌呈現他不同時期的重要創作。很適合親子家庭到訪，同時滿足孩子的藝術體驗、看表演、玩樂、用餐等多方面需求。")])])], 1), _vm._v(" "), _c('h5', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('span', {
    staticStyle: {
      "border-bottom": "1px solid #fff",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Places'
        })
      }
    }
  }, [_vm._v("景點列表")])])], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5 bg--white",
    attrs: {
      "id": "anchor-3"
    }
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("下載方式")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("這麼酷的APP還不快下載")]), _vm._v(" "), _c('v-row', {
    staticClass: "pa-3"
  }, [_c('v-col', {
    attrs: {
      "xs12": "",
      "offset-sm3": "",
      "sm3": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/tw/app/%E6%96%B0%E5%8C%97%E5%B8%82%E8%8B%B1%E8%AA%9E%E6%99%BA%E6%85%A7%E5%9F%8E/id1337959562?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_02.png")
    }
  })])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.liveabc.ntc4g",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon_03.png")
    }
  })])])], 1), _vm._v(" "), (false) ? _c('v-row', {
    staticClass: "mt-3 text-xs-left"
  }, [_c('v-col', {
    attrs: {
      "offset-sm1": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "ma-4 pb-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 1 免費註冊")]), _vm._v(" "), _c('p', [_vm._v("下載並開啟『新北市英語智慧城』 APP，完成 LiveABC 會員註冊程序，即可免費獲得「國立臺灣美術館」課程，前往景點學習。")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "ma-4 pb-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 2 進入課程")]), _vm._v(" "), _c('p', [_vm._v("購買悠活30方案或暢遊365方案，進入學習課程。透過 GPS 定位，開啟互動影音課程，體驗浸潤式的英語學習樂趣。")])]), _vm._v(" "), _c('hr', {
    staticClass: "hidden-sm-and-up"
  })]), _vm._v(" "), _c('v-col', {
    attrs: {
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "ma-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 3 挑戰任務")]), _vm._v(" "), _c('p', [_vm._v("課程中安排了許多英語學習任務，透過 GPS 定位及 AR 擴增實境，解鎖景點，從生活場域中發現你所看的聽的都是英文，答對了可立即獲得獎勵來福幣。")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "ma-4 pb-4",
    staticStyle: {
      "min-height": "9em"
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("Step 4 兌換好禮")]), _vm._v(" "), _c('p', [_vm._v("獎勵來福幣達指定數量時，即有機會兌換 LiveABC 提供的學習禮物，實際兌換禮物依網站公告為準。")])])])], 1) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "pa-5",
    attrs: {
      "id": "anchor-4"
    }
  }, [_c('h4', {
    staticClass: "primary-color title"
  }, [_vm._v("購買方案")]), _vm._v(" "), _c('p', {
    staticClass: "primary-color desc"
  }, [_vm._v("選擇適合您的旅遊學習方式，跟著我們走到哪學到哪。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "background-color": "#fff",
      "color": "red",
      "padding": "1em"
    }
  }, [_vm._v("即日起 ~ 2018/10/31 限時免費使用")]), _vm._v(" "), _c('v-row', {
    staticClass: "ma-3 mt-5 text-xs-center average"
  }, [_c('v-col', {
    staticClass: "ma-3 pa-5 bg--light",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("體驗方案")]), _c('br'), _vm._v("\n        90天"), _c('br'), _vm._v("定價 199元"), _c('br')]), _vm._v(" "), _c('v-col', {
    staticClass: "ma-3 pa-5 bg--light",
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('span', {
    staticClass: "sub-title"
  }, [_vm._v("暢遊方案")]), _c('br'), _vm._v("\n        365天"), _c('br'), _vm._v(" 定價 699元"), _c('br')])], 1), _vm._v(" "), _c('p', {
    staticClass: "primary-color mt-5"
  }, [_vm._v("小編提醒：建議搭配4G行動上網方案體驗「遊新北學英語」景點課程，確保學習服務順暢。")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ebb2fc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 777
// module chunks = 1